import axios from "@/axios";

export function AuthorizeById(id) {
  return axios.post(`users/auth/${id}`);
}
